const BASE_URL = process.env.NEXT_PUBLIC_API_URL;

function joinUrl(base: string, path: string) {
  const b = base.replace(/\/$/, "");
  const p = path.replace(/^\/+/, "");
  return `${b}/${p}`;
}

export async function apiFetch<T>(
  path: string,
  options?: RequestInit
): Promise<T> {
  // Normalize path (remove leading "/")
  const normalizedPath = path.replace(/^\/+/, "");

  // In the browser, always use same-origin relative path to avoid CORS
  const isBrowser = typeof window !== "undefined";
  const url = isBrowser
    ? `/api/${normalizedPath}`
    : BASE_URL
    ? joinUrl(BASE_URL, normalizedPath)
    : `/api/${normalizedPath}`;

  let headers: HeadersInit = options?.headers || {};

  // On the server, forward cookies to internal API calls
  try {
    const { cookies } = await import("next/headers");
    const cookieStore = await cookies();
    headers = {
      ...headers,
      Cookie: cookieStore.toString(),
    };
  } catch {
    // running on the client, nothing to do
  }

  const res = await fetch(url, {
    // include credentials for same-origin cookies when needed
    credentials:
      options?.credentials ?? (isBrowser ? "same-origin" : "include"),
    ...options,
    headers,
  });

  if (!res.ok) {
    throw res;
  }

  const json = await res.json();
  return json.data as T;
}
